export default async (response: Response) => {
  if (!response.ok) {
    const data = await response.json();
    if (data.status || !response.status) {
      throw data;
    }
    throw { ...data, status: response.status };
  }
  return response;
};
